import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import 'components-jqueryui';
import 'parsleyjs';
import {useSelector} from 'react-redux';
import amenities from "../../../persist/amenities";
import closestPlace from "../../../persist/closestPlace";
import Resizer from 'react-image-file-resizer';
import {NavLink} from "react-router-dom";
import {GET_AGENT_DATA, EDIT_PROPERTY_URL, FETCH_URL} from "../../../api";
import cogoToast from "cogo-toast";
import { Pannellum } from "pannellum-react";
import myImage from "../../../assets/img/20200918_184542_153.jpg";
import {decodeQueryParameter} from "../../../utils/url";
import tempCountryList from "../../../persist/countries";
import 'select2';
import {getCountryData, getCategory} from "../../../request/apps";
import axios from "axios";
import {capitalize} from "../../../utils/capitalize";

const EditProperty = (props) => {

    const property_data = decodeQueryParameter(props.match.params.property.replace(/'/g, ""));

    document.title = "Edit Property";

    const option = {
        hideAfter: 5
    };

    const token = localStorage.getItem('jwtToken');
    const auth = useSelector((state) => state.auth);

    const [property_raw, set_property_raw] = useState([]);
    const [stateReady, setStateReady] = useState(false);
    const [video_switched, set_video_switched] = useState(false);
    const [img_src, set_img_src] = useState("");
    const [img_name, set_img_name] = useState("");
    const [upload_image, set_upload_image] = useState([]);
    const [img_preview, set_img_preview] = useState("");
    const [property, set_property] = useState([]);
    const [previous, _previous] = useState("");
    const [ad_img, set_ad_img] = useState("");
    const [countrySelected, setCountrySelected] = useState("");
    const [stateSelected, setStateSelected] = useState("");
    const [stateList, setStateList] = useState([]);
    const [countryList, setCountryList] = useState([tempCountryList]);
    const [categoryList, setCategoryList] = useState([]);
    const [agent, setAgent] = useState("");

    const [panorama_preview, set_panorama_preview] = useState(myImage);
    const [panorama_src, set_panorama_src] = useState("");
    const [panorama_name, set_panorama_name] = useState("");
    const [panorama_img, set_panorama_img] = useState("");

    $(function () {
        var app = app || {};

        // Utils
        (function ($, app) {
            'use strict';

            app.utils = {};

            app.utils.formDataSuppoerted = (function () {
                return !!('FormData' in window);
            }());

        }($, app));

        // Parsley validators
        (function ($, app) {
            'use strict';
            window.Parsley
                .addValidator('filemaxmegabytes', {
                    requirementType: 'string',
                    validateString: function (value, requirement, parsleyInstance) {
                        if (!app.utils.formDataSuppoerted) {
                            return true;
                        }

                        var file = parsleyInstance.$element[0].files;
                        var maxBytes = requirement * 10048576;

                        if (file.length === 0) {
                            return true;
                        }

                        return file.length === 1 && file[0].size <= maxBytes;

                    },
                    messages: {
                        en: 'File is to big'
                    }
                }).addValidator('filemimetypes', {
                requirementType: 'string',
                validateString: function (value, requirement, parsleyInstance) {

                    if (!app.utils.formDataSuppoerted) {
                        return true;
                    }

                    var file = parsleyInstance.$element[0].files;

                    if (file.length === 0) {
                        return true;
                    }

                    var allowedMimeTypes = requirement.replace(/\s/g, "").split(',');
                    return allowedMimeTypes.indexOf(file[0].type) !== -1;

                },
                messages: {
                    en: 'Only jpeg, gif and png is allowed'
                }
            }).addValidator('filemaxmegabytes', {
                requirementType: 'string',
                validateString: function (value, requirement, parsleyInstance) {

                    let file = parsleyInstance.$element[0].files[0];
                    let image = new Image();
                    let deferred = $.Deferred();

                    image.src = window.URL.createObjectURL(file);
                    image.onload = function() {

                        if(parsleyInstance.$element[0].id === "panorama_image") {
                            var ratio = image.width/2;

                            if (ratio >= image.height) {
                                deferred.resolve();
                            } else {
                                deferred.reject();
                            }
                        } else {
                            if (image.height / image.width <= 1.4) {
                                deferred.resolve();
                            }
                            else {
                                deferred.reject();
                            }
                        }
                    };

                    return deferred.promise();
                },
                messages: {
                    en: 'Please upload panorama and cover image as landscape images only.'
                }
            });
        }($, app));
    });

    useEffect(() => {

        $('#name').val(property_data.name);
        $('#category').val(property_data.category);
        $('#beds').val(property_data.number_bedroom);
        $('#bathtub').val(property_data.number_bathtub);
        $('#type').val(capitalize(property_data.price.type));
        $('#price').val(property_data.price.tag);
        $('#currency').val(property_data.price.currency);
        $('#description').val(property_data.description);

        if(property_data.amenities.length > 0) {
            for(let i = 0; i < property_data.amenities.length; ++i) {
                let option = [];
                option[i] = new Option(property_data.amenities[i].name, property_data.amenities[i].name);
                option[i].selected = true;

                $("#amenities").append(option).trigger("change");
            }
        }

        if(property_data.closest_place.length > 0) {
            for(let i = 0; i < property_data.closest_place.length; ++i) {
                let option = [];
                option[i] = new Option(property_data.closest_place[i].name, property_data.closest_place[i].name);
                option[i].selected = true;

                $("#nearby").append(option).trigger("change");
            }
        }

        let agent_opt = new Option(property_data.agent.email, property_data.agent.email);
        agent_opt.selected = true;

        $("#agent").append(agent_opt).trigger("change");

        set_property(property_data.specs);

        getCountryData().then((response) => {
            if(!response.error) {
                setCountryList(response.data);
            }
        });

        getCategory().then((response) => {
            if(!response.error) {
                setCategoryList(response.data);
            }
        });

        set_property(property_data.specs.map((data) => {
            return ({
                index: data._id,
                item_name: data.name,
                new: true,
                panorama_preview: FETCH_URL + data.panorama_img,
                img_preview: FETCH_URL + data.cover_img
            })
        }));

        $("#_basic").on('submit', function(e){
            e.preventDefault();
        });

        $("#_location").on('submit', function(e){
            e.preventDefault();
        });

        $("#add_property_item").on('submit', function(e){
            e.preventDefault();
        });

        $('.amenities-select2').select2({
            placeholder: 'Enter amenities or features',
            data: amenities
        });

        $('.nearby-select2').select2({
            placeholder: 'Enter closest place',
            data: closestPlace
        });

        $('.agent-select2').select2({
            minimumInputLength: 3,
            maximumSelectionLength: 1,
            placeholder: 'Enter agent name',
            ajax: {
                url: GET_AGENT_DATA,
                dataType: 'json',
                type: "POST",
                headers: {
                    "Authorization" : token,
                },
                data: function (query) {
                    return {
                        query: query
                    };
                },
                processResults: function (data) {
                    return {
                        results: $.map(data, function (item) {
                            setAgent(item._id);
                            return {
                                text: item.name,
                                id: item
                            }
                        })
                    };
                }
            }
        });

        return () => {
            $("#date_from").datepicker("destroy");
            $('#_basic').parsley().destroy();
            $('#_location').parsley().destroy();
        }
    }, []);

    const handleNext = () => {
        if($('#name').parsley().isValid() && $('#price').parsley().isValid() && $('#agent').parsley().isValid() && $('#description').parsley().isValid() && $('#beds').parsley().isValid() && $('#bathtub').parsley().isValid()) {
            $('#property_basic .active').parent().next('li').find('a').trigger('click');
        }
    };

    const handlePrevious = () => {
        $('#property_basic .active').parent().prev('li').find('a').trigger('click');
    };

    const generateId = (length) => {
        let text = "";
        let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    };

    const handlePropertyValidate = () => {
        if(property.length === 0) {
            return cogoToast.error("Please add one or more property before you proceed.");
        }

        $('.nav-line .active').parent().next('li').find('a').trigger('click');
    };

    const handleModal = () => {
        $('#property_title').text("Create Property");
        $('#image').prop("required", true);

        $('#modalAddGallery').modal({
            backdrop: 'static',
            keyboard: false
        });

        $('#add_property_item').parsley();

        $("#modalCreateAd").modal("show");
    }

    const handlePanoramaUpload = (event) => {
        if(event.target.files[0] !== undefined && $('#panorama_image').parsley().isValid() !== false) {
            let file = event.target.files[0];
            let image = new Image();
            image.src = window.URL.createObjectURL(file);
            image.onload = function() {
                var ratio = image.width/2;

                if (ratio >= image.height) {
                    Resizer.imageFileResizer(
                        file,
                        6080,
                        3040,
                        'JPEG',
                        40,
                        0,
                        uri => {
                            set_panorama_preview(uri);
                        },
                        'base64'
                    );

                    set_panorama_src(generateId(50));
                    set_panorama_name(file.name);
                    set_panorama_img(file);
                }
            };
        }
    }

    const handleFileUpload = (event) => {
        if(event.target.files[0] !== undefined && $('#cover_image').parsley().isValid() !== false) {
            let file = event.target.files[0];
            let image = new Image();
            image.src = window.URL.createObjectURL(file);
            image.onload = function() {
                if (image.height / image.width <= 1.4) {
                    Resizer.imageFileResizer(
                        file,
                        1280,
                        720,
                        'JPEG',
                        90,
                        0,
                        uri => {
                            set_img_preview(uri);
                        },
                        'base64'
                    );

                    set_img_src(generateId(50));
                    set_img_name(file.name);
                    set_ad_img(file);
                }
            };
        }
    };

    const handleDeleteProperty = (index) => {
        let filteredArray = property.filter(item => item.index !== index);
        set_property(filteredArray);
    };

    const clearAdForm = () => {
        $("#item_name").val(null);
        $('#panorama_image').val(null);
        $('#cover_image').val(null);
        $('#add_property_item').parsley().destroy();
    }

    const viewPanorama = (data) => {
        $('#modalPanorama').modal({
            backdrop: 'static',
            keyboard: false
        });

        set_panorama_preview(data)

        $("#modalPanorama").modal("show");
    }

    const handleAddGallery = () => {
        if(
            $('#item_name').parsley().isValid() == false ||
            $('#cover_image').parsley().isValid() == false
        ) {
            return null;
        }

        $("#modalAddGallery").modal("hide");
        $(".modal-backdrop").remove();

        let data = {
            index: img_src,
            item_name: $('#item_name').val(),
            panorama_preview: panorama_preview,
            img_preview: img_preview
        };

        set_property([...property, data]);
        clearAdForm();
    };

    const handleCountrySelected = (event) => {
        setCountrySelected(event.target.value);

        let result = countryList.find((data) => {
            return data.name === event.target.value;
        });

        setStateList(result.state);
    };

    const handleStateSelected = (event) => {
        setStateSelected(event.target.value);
    }

    const handleProceed = () => {
        if($('#country').parsley().isValid() && $('#state').parsley().isValid() && $('#address').parsley().isValid()) {

            let formData = {
                name: $('#name').val(),
                category: $('#category').val(),
                type: $('#type').val(),
                price: $('#price').val(),
                currency: $('#currency').val(),
                bed: $('#beds').val(),
                bathtub: $('#bathtub').val(),
                description: $('#description').val(),
                amenities: $('#amenities').val(),
                nearby: $('#nearby').val(),
                agent: agent,
                country: $('#country').val(),
                state: $('#state').val(),
                location: $('#address').val(),
                gallery: property
            }

            let config = {
                crossorigin: true
            }

            setStateReady(true);

            axios.post(EDIT_PROPERTY_URL, formData, config).then((response) => {
                let {payload} = response.data;
                if(payload === "success") {
                    props.history.push('/property');
                }
            }).catch((err) => {
                console.log(err);
                setStateReady(false);

                return false;

                const option = {
                    hideAfter: 3
                };

                cogoToast.error(err.response.data.error, option);
            });
        }
    }

    let renderAd = () => {
        if (property.length === 0) {
            return (
                <div className="row row-sm">
                    <div className="container d-flex justify-content-center ht-350">
                        <div
                            className="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center">
                            <div className="wd-80p wd-sm-300 mg-b-15 tx-center"><i className="wd-60 ht-60 tx-color-03" data-feather="image"/></div>
                            <p className="tx-color-03 mg-b-30 tx-center">Accepted image files: JPEG Only.<br/>Maximum file size: 10MB</p>
                            <button className="btn btn-brand-02 outline-none" onClick={handleModal.bind()} data-toggle="modal"><i data-feather="plus"/> Create</button>
                        </div>
                    </div>
                </div>
            )
        } else {
            const renderPropertyItems = property.map((result, index) => {
                return (
                    <div className="col-lg-3 col-md-3" key={index}>
                        <div className="card card-body pd-8 mg-b-20 pd-b-4">
                            <div className="media">
                                <div className="media-body">
                                    <img src={result.img_preview} className="img-fit-cover rounded" alt=""/>
                                    <h6 className="tx-uppercase tx-12 tx-spacing-1 tx-color-02 tx-bold mg-t-8 mg-b-8">{result.item_name}</h6>
                                    <nav className="nav nav-icon-only">
                                        <h6 className="tx-uppercase tx-10 tx-spacing-1 tx-color-02 tx-normal mg-b-8"><NavLink to="#" className="nav-link" onClick={viewPanorama.bind(null, result.panorama_preview)}>View 360</NavLink></h6>
                                    </nav>
                                    <nav className="nav nav-icon-only">
                                        <NavLink to="#" className="nav-link" onClick={handleDeleteProperty.bind(null, result.index)}><i className="fa fa-trash-alt"/> Delete</NavLink>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            });

            return (
                <div className="row row-sm">
                    {renderPropertyItems}
                    <div className="col-lg-3 col-md-3 container d-flex justify-content-center">
                        <div
                            className="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center">
                            <p className="tx-color-03 mg-b-10 tx-center">Accepted image files: PNG, JPEG, GIF.<br/>Resolution
                                Min: 1280x720 upward<br/>Maximum file size: 1MB</p>
                            <button className="btn btn-sm btn-brand-02 outline-none" onClick={handleModal.bind()}
                                    data-toggle="modal"><i data-feather="plus"/> Create
                            </button>
                        </div>
                    </div>
                </div>
            );
        }
    }

    let renderProceedButton = () => {
        if(stateReady === true) {
            return(
                <button className="btn btn-brand-02 float-right" disabled>
                    <span className="spinner-border spinner-border-sm mg-r-10" aria-hidden="true"/>Please Wait</button>
            )
        } else {
            return(
                <button className="btn btn-brand-01 float-right" onClick={handleProceed.bind()}>Proceed <i className="ion-md-arrow-forward"/></button>
            );
        }
    };

    return (
        <div className="content">
            <div className="content-body">
                <div className="container container pd-x-0 pd-lg-x-10 pd-xl-x-0">
                    <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                        <div>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                    <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">View</li>
                                </ol>
                            </nav>
                            <h4 className="mg-b-0 tx-spacing--1">Edit Property</h4>
                        </div>
                    </div>
                    <div className="card card-body pd-x-25 pd-sm-x-30 pd-t-15 pd-sm-t-20 pd-b-15 pd-sm-b-20">
                        <div className="nav-wrapper mg-b-20 tx-13">
                            <div>
                                <ul id="property_basic" className="nav nav-line nav-fill tx-medium nav-disabled">
                                    <li className="nav-item"><a href="#basic" className="nav-link active" data-toggle="tab"><i className="ion-md-information-circle-outline"/> Basic</a></li>
                                    <li className="nav-item"><a href="#upload" className="nav-link" data-toggle="tab"><i className="ion-md-document"/> Upload</a></li>
                                    <li className="nav-item"><a href="#location" className="nav-link" data-toggle="tab"><i className="ion-md-navigate"/> Location</a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="tab-content">
                            <div id="basic" className="tab-pane fade active show">
                                <form id="_basic" className="parsley-style-1" data-parsley-validate noValidate>
                                    <h5 className="tx-semibold">Basic Information</h5>
                                    <section>
                                        <div className="row row-sm">
                                            <div id="propertyWrapper" className="form-group parsley-input col-sm-6">
                                                <label>Property<span className="tx-danger">*</span></label>
                                                <select className="custom-select"
                                                        id="category"
                                                        required>
                                                    <option value="" disabled>Select</option>
                                                    {categoryList.map((result) => <option key={result.name} value={result._id}>{result.name}</option>)}
                                                </select>
                                            </div>

                                            <div id="typeWrapper" className="form-group parsley-input col-sm-6">
                                                <label>Type<span className="tx-danger">*</span></label>
                                                <select className="custom-select" id="type" required>
                                                    <option value="Rent">Rent</option>
                                                    <option value="Sale">Sale</option>
                                                </select>
                                            </div>

                                            <div id="cnWrapper" className="form-group parsley-input col-sm-6">
                                                <label>Name<span className="tx-danger">*</span></label>
                                                <input id="name" className="form-control"
                                                       placeholder="Enter name"
                                                       type="text"
                                                       autoComplete="off"
                                                       data-parsley-class-handler="#cnWrapper" required/>
                                            </div>

                                            <div id="bWrapper" className="form-group parsley-input col-sm-3">
                                                <label>Number of Bed<span className="tx-danger">*</span></label>
                                                <input id="beds" className="form-control" name="price"
                                                       placeholder="Enter number of bed" type="number"
                                                       min={1}
                                                       autoComplete="off"
                                                       data-parsley-class-handler="#bWrapper" required/>
                                            </div>

                                            <div id="baWrapper" className="form-group parsley-input col-sm-3">
                                                <label>Number of Bathtub<span className="tx-danger">*</span></label>
                                                <input id="bathtub" className="form-control" name="price"
                                                       placeholder="Enter numebr of bathtub" type="number"
                                                       min={1}
                                                       autoComplete="off"
                                                       data-parsley-class-handler="#baWrapper" required/>
                                            </div>

                                            <div id="bgWrapper" className="form-group parsley-input col-sm-6">
                                                <label>Price<span className="tx-danger">*</span></label>
                                                <input id="price" className="form-control" name="price"
                                                       placeholder="Enter price" type="number"
                                                       min={0}
                                                       autoComplete="off"
                                                       data-parsley-class-handler="#bgWrapper" required/>
                                            </div>

                                            <div id="currencyWrapper" className="form-group parsley-input col-sm-6">
                                                <label>Currency<span className="tx-danger">*</span></label>
                                                <select id="currency" className="custom-select" required>
                                                    {countryList.map((result, index) => <option key={index} value={result.currency}>{result.currency}</option>)}
                                                </select>
                                            </div>

                                            <div id="instructionWrapper" className="form-group parsley-input col-sm-12">
                                                <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Description</label>
                                                <textarea id="description" type="text" rows="5" className="form-control" placeholder="Provide a descipriton of the property" data-parsley-class-handler="#instructionWrapper" required></textarea>
                                            </div>

                                            <div id="amenitiesWrapper" className="form-group parsley-input col-sm-12">
                                                <label>Amenities</label>
                                                <select className="form-control wd-438 amenities-select2" multiple="multiple"
                                                        data-parsley-class-handler="#amenitiesWrapper"
                                                        data-parsley-errors-container="#amenitiesWrapper"
                                                        id="amenities">
                                                </select>
                                            </div>

                                            <div id="nearbyWrapper" className="form-group parsley-input col-sm-12">
                                                <label>Nearby Place</label>
                                                <select className="form-control wd-438 nearby-select2" multiple="multiple"
                                                        data-parsley-class-handler="#nearbyWrapper"
                                                        data-parsley-errors-container="#nearbyWrapper"
                                                        id="nearby">
                                                </select>
                                            </div>

                                            <div id="agentWrapper" className="form-group parsley-input col-sm-12">
                                                <label>Agent<span className="tx-danger">*</span></label>
                                                <select className="form-control wd-438 agent-select2" multiple="multiple"
                                                        data-parsley-class-handler="#agentWrapper"
                                                        data-parsley-errors-container="#agentWrapper"
                                                        id="agent"
                                                        required>
                                                </select>
                                            </div>
                                        </div>
                                    </section>
                                    <hr/>
                                    <button className="btn btn-brand-01 float-right btnNextFront" onClick={handleNext.bind()}>Next <i className="ion-md-arrow-forward"/></button>
                                </form>
                            </div>
                            <div id="upload" className="tab-pane fade">
                                <h5 className="tx-semibold">Gallery</h5>
                                <section className="mg-t-10">
                                    {renderAd()}
                                </section>
                                <button className="btn btn-dark float-left btnPrevious" onClick={handlePrevious.bind()}><i className="ion-md-arrow-back"/> Back</button>
                                <button className="btn btn-brand-01 float-right btnNextAd" onClick={handlePropertyValidate.bind()}>Next <i className="ion-md-arrow-forward"/></button>
                            </div>
                            <div id="location" className="tab-pane fade">
                                <form id="_location" className="parsley-style-1" data-parsley-validate noValidate>
                                    <h5 className="tx-semibold">Location</h5>
                                    <section>
                                        <div className="row row-sm">
                                            <div id="countryWrapper" className="form-group parsley-input col-sm-12">
                                                <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Country</label>
                                                <select className="custom-select"
                                                        id="country"
                                                        value={countrySelected}
                                                        onChange={handleCountrySelected.bind()}
                                                        required>
                                                    <option value="" disabled>Select</option>
                                                    {countryList.map((result, index) => <option key={index} value={result.name}>{result.name}</option>)}
                                                </select>
                                            </div>
                                            <div id="stateWrapper" className="form-group parsley-input col-sm-12">
                                                <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">State</label>
                                                <select className="custom-select"
                                                        id="state"
                                                        value={stateSelected}
                                                        data-parsley-class-handler="#stateWrapper"
                                                        data-parsley-errors-container="#stateWrapper"
                                                        onChange={handleStateSelected.bind()}
                                                        required>
                                                    <option value="" disabled>Select</option>
                                                    {stateList.map((result) => <option key={result.name} value={result.name}>{result.name}</option>)}
                                                </select>
                                            </div>
                                            <div id="locationWrapper" className="form-group parsley-input col-sm-12">
                                                <label>Location<span className="tx-danger">*</span></label>
                                                <input id="address" className="form-control"
                                                       placeholder="Enter location"
                                                       type="text"
                                                       autoComplete="off"
                                                       data-parsley-class-handler="#locationWrapper" required/>
                                            </div>
                                        </div>
                                    </section>
                                    <hr/>
                                    <button className="btn btn-dark float-left btnPrevious" disabled={previous} onClick={handlePrevious.bind()}><i className="ion-md-arrow-back"/> Back</button>
                                    {renderProceedButton()}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalAddGallery" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                    <div className="modal-content">
                        <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                            <div className="media align-items-center">
                                <div className="media-body">
                                    <a href="" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close" onClick={clearAdForm.bind()}>
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <h4 id="property_title" className="tx-18 tx-sm-20 mg-b-2">Add Space</h4>
                                </div>
                            </div>
                        </div>
                        <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                            <form id="add_property_item">
                                <div id="nameWrapper" className="form-group parsley-input">
                                    <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Name</label>
                                    <input id="item_name" type="text" className="form-control"
                                           placeholder="Enter name"
                                           autoComplete="off"
                                           data-parsley-class-handler="#nameWrapper" required/>
                                </div>

                                <div className="form-group">
                                    <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Upload Images</label>
                                    <input id="cover_image" type="file" className="form-control"
                                           onChange={handleFileUpload.bind()}
                                           data-parsley-filemaxmegabytes="1"
                                           data-parsley-trigger="change"
                                           data-parsley-filemimetypes="image/jpeg, image/png, image/gif, image/jpg"
                                           required
                                    />
                                </div>

                                <div className="form-group">
                                    <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Upload Panorama</label>
                                    <input name="state" id="panorama_image" type="file" className="form-control"
                                           onChange={handlePanoramaUpload.bind()}
                                           data-parsley-filemaxmegabytes="1"
                                           data-parsley-trigger="change"
                                           data-parsley-filemimetypes="image/jpeg, image/png, image/gif, image/jpg"
                                           required
                                    />
                                </div>
                                <button className="btn btn-success float-right" onClick={handleAddGallery.bind()}><i className="fa fa-check-circle"/> Finish</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalPanorama" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                            <div className="media align-items-center">
                                <div className="media-body">
                                    <a href="" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close" onClick={clearAdForm.bind()}>
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <h4 id="property_title" className="tx-18 tx-sm-20 mg-b-2">Panorama View</h4>
                                </div>
                            </div>
                        </div>
                        <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                            <Pannellum
                                width="100%"
                                height="500px"
                                image={panorama_preview}
                                pitch={10}
                                yaw={180}
                                hfov={110}
                            >
                            </Pannellum>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default EditProperty;
